export default {
  navRooms: 'Rooms',
  navAusflugsziele: 'Things to do',
  navLocation: 'Location',
  navHotel: 'The Hotel',
  navContact: 'Contact & Directions',
  navBook: 'Book now',
  hotelName: 'Hotel Alpenhof',
  langSwitch: 'DE',
  sliderPrev: 'Previous image',
  sliderNext: 'Next image',
  close: 'Close',
};
